import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { ArrowUpIcon } from '@root/shared/ui-kit'

import { PairActivitySnackbarBase } from './pair-activity-snackbar-base'

import type { PairActivity } from '../model'

export type PairActivitySnackbarAthProps = {
  activity: PairActivity.HighestAth
  onClose?: () => void
}

export const PairActivitySnackbarAth = ({
  activity,
  onClose,
}: PairActivitySnackbarAthProps) => {
  return (
    <PairActivitySnackbarBase onClose={onClose} activity={activity}>
      <Ath>
        <ArrowUpIcon size={12} />{' '}
        <LabelAth>
          ATH{' '}
          <Numeric
            value={activity.athPriceUsd}
            preset="currency-amount-short"
            currency="$"
          />
        </LabelAth>
      </Ath>
      <Separator />
      <Currency>
        <CurrencyIcon currency={activity.currency} size={24} withNetwork />{' '}
        <LabelCurrency>{activity.currency.title}</LabelCurrency>
      </Currency>
    </PairActivitySnackbarBase>
  )
}

const Ath = styled.div`
  color: var(--amber-9);

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;
`

const LabelAth = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  gap: 4px;
`

const Separator = styled.div`
  background: var(--backgroundA-4);
  width: 1px;
  height: 14px;
`

const Currency = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const LabelCurrency = styled.div`
  color: var(--text-12);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`
